import { LazySearchProductsRelatedSearchSection } from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/SearchProductsRelatedSearchSection/index";
import { discoverSearch } from "@faire/deprecated-retailer-visitor-shared/lib/seoPaths";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { trackSeoRelatedSearchesOnLoggedOutCategoryPageClick } from "@faire/web-api--source/events/seo/click/relatedSearchesOnLoggedOutCategoryPage";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";
import styled from "styled-components";

export const LoggedOutCategoryPageRelatedSearches: React.FC = () => {
  const navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
  const productRelatedSearches =
    useLoggedOutCategoryPageCatNavResponse().data.relatedSearchTerms;
  return (
    <WhenVisibilityIsImminent>
      <Suspense fallback={null}>
        {productRelatedSearches?.length ? (
          <>
            <StyledLazySearchProductsRelatedSearchSection
              relatedSearchTerms={productRelatedSearches ?? []}
              onSearchTermClick={(searchTerm: string) => {
                trackSeoRelatedSearchesOnLoggedOutCategoryPageClick(
                  navigationPath,
                  searchTerm
                );
              }}
              generateSearchTermUrl={discoverSearch}
              leftAlign={false}
            />
            <Spacer height="8x" />
          </>
        ) : null}
      </Suspense>
    </WhenVisibilityIsImminent>
  );
};

const StyledLazySearchProductsRelatedSearchSection = styled(
  LazySearchProductsRelatedSearchSection
)`
  ${responsiveMediaQueries.mobile} {
    width: 100%;
    padding: ${getSpacing("0", "2x")};
  }
`;
